import * as React from "react";
import { useEffect } from 'react';

import {EcommProductPrice} from "@arctheme-components/ecommerce/Price/Price";

export const ProductRatings = ({ product, rating_system = 'default' }) => {

    useEffect(() => {
        if (rating_system == 'reviews_io'){
            // @ts-ignore
            const ratingSnippet: any = window.ratingSnippet;

            if (ratingSnippet) {
                ratingSnippet("ruk_rating_snippet", {
                    store: "zero-co",
                    mode: "default",
                    color: "#0E1311",
                    usePolaris: false,
                    showEmptyStars: true,
                });
            }
        }
    }, []);

    return (
        <>
            {rating_system == 'default' && <div className="product-tile__reviews">
                <div className="flex w-full justify-between">
                    <div className="flex items-center gap-x-[8px] bl">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="68"
                            height="13"
                            viewBox="0 0 68 13"
                            fill="none"
                        >
                            <path
                                d="M6 0.5L7.76336 4.07295L11.7063 4.6459L8.85317 7.42705L9.52671 11.3541L6 9.5L2.47329 11.3541L3.14683 7.42705L0.293661 4.6459L4.23664 4.07295L6 0.5Z"
                                fill="black"
                            />
                            <path
                                d="M20 0.5L21.7634 4.07295L25.7063 4.6459L22.8532 7.42705L23.5267 11.3541L20 9.5L16.4733 11.3541L17.1468 7.42705L14.2937 4.6459L18.2366 4.07295L20 0.5Z"
                                fill="black"
                            />
                            <path
                                d="M34 0.5L35.7634 4.07295L39.7063 4.6459L36.8532 7.42705L37.5267 11.3541L34 9.5L30.4733 11.3541L31.1468 7.42705L28.2937 4.6459L32.2366 4.07295L34 0.5Z"
                                fill="black"
                            />
                            <path
                                d="M48 0.5L49.7634 4.07295L53.7063 4.6459L50.8532 7.42705L51.5267 11.3541L48 9.5L44.4733 11.3541L45.1468 7.42705L42.2937 4.6459L46.2366 4.07295L48 0.5Z"
                                fill="black"
                            />
                            <path
                                d="M62 0.5L63.7634 4.07295L67.7063 4.6459L64.8532 7.42705L65.5267 11.3541L62 9.5L58.4733 11.3541L59.1468 7.42705L56.2937 4.6459L60.2366 4.07295L62 0.5Z"
                                fill="black"
                            />
                        </svg>
                        <span className={'hidden lg:block text-xs'}>(1140)</span>
                    </div>
                </div>
            </div>}

            {rating_system == 'reviews_io' &&
            <div
                className="ruk_rating_snippet test"
                data-test={""}
                data-sku={`${product?.handle};${product?.variants?.map(v => v.sku).join(';')};${product?.variants?.map(v => v.id).join(';')}`}
            >
            </div>}
        </>
    );
};
